import Banner from "../components/Banner/Banner";
import Footer from "../components/Footer/Footer";
import JobListSection from "../components/JobList/JobListSection";
import Navigation from "../components/Navigation/Navigation";
import Spinner from "../components/Spinner/Spinner";

function JobList() {
  return (
    <div className="container-xxl bg-white p-0">
      <Spinner />
      <Navigation />
      <Banner pageName="Job List" />
      <JobListSection />
      <Footer />
    </div>
  );
}

export default JobList;
